/* tslint:disable */
/* eslint-disable */
export enum AlertTypeEnum {
  NotSet = 0,
  AiSocketNoData = 1,
  BizlabAIUpdateFailed = 2,
  BizlabAdvertiserUpdateFailed = 3
}
